import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {  FormArray, FormBuilder, FormControl, FormGroup,  Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';

import { Subject } from 'rxjs/Rx';
declare var $: any;
import * as _ from 'lodash';
import { TaskService } from 'src/app/services/task.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertComponent } from '../../alert/alert.component';
import { UserTeamMasterService } from 'src/app/services/user-team-master.service';
@Component({
  selector: 'app-user-team-master',
  templateUrl: './user-team-master.component.html',
  styleUrls: ['./user-team-master.component.css']
})
export class UserTeamMasterComponent implements OnInit, AfterViewInit {

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();
  defaultMeetingMasterData: any[];
  dftMeetingId: any;
  dataAvailable: boolean;
  activatedUserList: any[];
  activatedUser: any[];
  selectedOption;
  userTeamMasterForm: FormGroup;
  taskCronDetailsForm: FormGroup;
  username_id: any;
  userTeamMasterId: any;
  activatedUserListForEdit = [];
  modelTitle: any;
  btnTitle: any;
  CronDates: any = [];
  dataarray = [];
  newFieldAttribute: any;
  newFieldArray: { id: number; title: string; }[];
  addholding: boolean;
  disabledOnClick: boolean;
  holdingList: any;
  CronConfigurationsList: any[];
  holdersdata: any;
  addBtn: boolean = true;
  dtOptionsOfHolding: DataTables.Settings = {};
  dtTriggerHolding: Subject<any> = new Subject();
  editParticularId: any;
  holdingdata: any;
  deleteholdingId: any;
  array: any;
  constructor(
    private taskService: TaskService,
    private router: Router,
    private alert: AlertComponent,
    private userteammasterService: UserTeamMasterService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {

    this.modelTitle = "Add";
    this.btnTitle = "Save";
    this.CronDates = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
    this.userTeamMasterForm = new FormGroup({
      username: new FormControl('', []),
      colleague: new FormControl('', []),
      escalation1: new FormControl('', []),
      escalation2: new FormControl('', [])
    });
    // this.taskCronDetailsForm =new FormGroup({
    //   cronName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ,.'&-]*$")]),
    //   cronFrequency: new FormControl('', [Validators.required]),
    //   weeklyDay: new FormControl('', [Validators.required]),
    //   cronDate: new FormControl('', [Validators.required]),
    //   noOfDays: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ,.'&-]*$")]),
    //   emailTo: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ,.'&-]*$")]),
    // });

    this.taskCronDetailsForm = this.formBuilder.group({
      newField: new FormArray([
        // this.initialiseNewFieldArray()
      ]),
    });
    this.newFieldArray = [];
    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        // this.addholding = true;
        this.editParticularId = params['particularId'];
        this.getTaskCronDetailsById(this.editParticularId);
        // this.isJointHolder = false;
      } else {
        // this.addholding = false;
      }
    })




    this.getDefaultUserSelectionList();

    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }],
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [{
        text: '<i class="fa fa-files-o"></i> Export to Excel',
        className: 'btn btn-sm btn-warning export-btn',
        filename: 'User Team Master List',
        title: 'User Team Master List',
        extend: 'excel',
        exportOptions: {
          columns: [0, 1, 2, 3],
          format: {
            body: function ( data, row, column, node ) {
                if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                  if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                }else{ return data }
              }
          }
        }
      }]
    };
    this.dtOptionsOfHolding = {
      destroy: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [6] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Tasks Cron Details List',
          title: 'Tasks Cron Details List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]

    };
    this.getTaskCronDetails();
  }

  getUserTeamMasterData() {
    this.userteammasterService.getUserTeamMasterData()
      .subscribe(userMasterData => {
        console.log("userMasterData===>", userMasterData);

      })
  }

  ngAfterViewInit() {
    // $(function() {
    // // this.getDefaultUserSelectionList();
    // $('.selectpickerForColleague').selectpicker();
    // $('.selectpickerForEscalation1').selectpicker();
    // $('.selectpickerForEscalation2').selectpicker();
    // });
  }
  compareUsers = (o1: any, o2: any) => {
    return o1 && o2 && o1._id === o2._id;
  };
  addDefaultUsers(userId, userName, userTeamMasterId, colleagueUserList, escalation1List, escalation2List) {
    this.modelTitle = userTeamMasterId ? "Edit" : "Add";
    this.btnTitle = userTeamMasterId ? "Update" : "Save";
    this.userTeamMasterId = userTeamMasterId || '';
    this.username_id = userId;
  
    // Set username (read-only field)
    this.userTeamMasterForm.controls['username'].setValue(userName);
  
    // Normalize colleague input (array of user objects → array of userIds)
    const colleagueIds = Array.isArray(colleagueUserList)
      ? colleagueUserList.map(u => u?.userId || u)
      : [];
  
    const escalation1Ids = Array.isArray(escalation1List)
      ? escalation1List.map(u => u?.userId || u)
      : [];
  
    const escalation2Ids = Array.isArray(escalation2List)
      ? escalation2List.map(u => u?.userId || u)
      : [];
  
    // Patch form
    this.userTeamMasterForm.patchValue({
      colleague: colleagueUserList?.map(u => u?.userId || u) || [],
      escalation1: escalation1List?.map(u => u?.userId || u) || [],
      escalation2: escalation2List?.map(u => u?.userId || u) || []
    });
  
    // Disable already selected users across all dropdowns
    const selectedUsers = [...colleagueIds, ...escalation1Ids, ...escalation2Ids];
    this.activatedUserList = this.activatedUserList.map(u => ({
      ...u,
      disabled: selectedUsers.includes(u.value)
    }));
  
    // Open modal
    $('#userTeamMasterDialog').modal('show');
  }
  

  addUserTeamMaster() {
    this.removeAllDisables("All")
    var that = this;
    /* 
      this.userTeamMasterId
      User for update user team master data
     */
    var colleagueUserId;
    var escalation1UserId;
    var escalation2UserId;
    // if (this.userTeamMasterId) // For Update
    // {
    //   colleagueUserId = $('.selectpickerForColleague').val();
    //   // escalation1UserId = $('.selectpickerForEscalation1').val();
    //   // escalation2UserId = $('.selectpickerForEscalation2').val();
    // } else {
    // }
    colleagueUserId = this.userTeamMasterForm.controls.colleague.value;
    escalation1UserId = this.userTeamMasterForm.controls.escalation1.value;
    escalation2UserId = this.userTeamMasterForm.controls.escalation2.value;

    let userObject = _.find(this.activatedUserList, function (element) {
      return element._id == that.username_id
    });

    var colleagueObjectData = [];
    if (colleagueUserId != "" && colleagueUserId != undefined) {
      colleagueUserId.forEach(ele => {
        let colleagueObject = _.find(this.activatedUserList, function (element) {
          return element._id == ele
        });
        colleagueObjectData.push({
          userid: colleagueObject._id,
          UniqueUserId: colleagueObject.UniqueUserId,
          CompanyId: colleagueObject.CompanyId,
          EmailId: colleagueObject.EmailId,
          username: colleagueObject.FirstName + ' ' + colleagueObject.LastName
        })
      });

    } else {
      colleagueObjectData = null;
    }

    // For Colleague
    // var colleagueObjectData = {};
    // if (colleagueUserId != "" && colleagueUserId != undefined) {
    //   let colleagueObject = _.find(this.activatedUserList, function (element) {
    //     return element._id == colleagueUserId;
    //   });

    //   colleagueObjectData = {
    //     userid: colleagueObject._id,
    //     UniqueUserId: colleagueObject.UniqueUserId,
    //     CompanyId: colleagueObject.CompanyId,
    //     EmailId: colleagueObject.EmailId,
    //     username: colleagueObject.FirstName + ' ' + colleagueObject.LastName
    //   }

    // } else {
    //   colleagueObjectData = null;
    // }

    // For Escalation 1
    var escalation1ObjectData = [];
    if (escalation1UserId != "" && escalation1UserId != undefined) {
      escalation1UserId.forEach(ele => {
        let escalation1Object = _.find(this.activatedUserList, function (element) {
          return element._id == ele
        });
        escalation1ObjectData.push({
          userid: escalation1Object._id,
          UniqueUserId: escalation1Object.UniqueUserId,
          CompanyId: escalation1Object.CompanyId,
          EmailId: escalation1Object.EmailId,
          username: escalation1Object.FirstName + ' ' + escalation1Object.LastName
        })
      });

    } else {
      escalation1ObjectData = null;
    }
    // For Escalation 2
    var escalation2ObjectData = [];
    if (escalation2UserId != "" && escalation2UserId != undefined) {
      escalation2UserId.forEach(ele => {
        let escalation2Object = _.find(this.activatedUserList, function (element) {
          return element._id == ele
        });
        console.log("escalation2Objectescalation2Object", escalation2Object)
        escalation2ObjectData.push({
          userid: escalation2Object._id,
          UniqueUserId: escalation2Object.UniqueUserId,
          CompanyId: escalation2Object.CompanyId,
          EmailId: escalation2Object.EmailId,
          username: escalation2Object.FirstName + ' ' + escalation2Object.LastName
        })
      });
    } else {
      escalation2ObjectData = null;
    }

    let finalUserTeamMasterData = {
      userid: userObject._id,
      UniqueUserId: userObject.UniqueUserId,
      CompanyId: userObject.CompanyId,
      EmailId: userObject.EmailId,
      username: userObject.FirstName + ' ' + userObject.LastName,
      colleague: colleagueObjectData,
      escalation1: escalation1ObjectData,
      escalation2: escalation2ObjectData
    }

    if (this.userTeamMasterId) // For Update
    {
      this.userteammasterService.editUserTeamMaster(finalUserTeamMasterData, this.userTeamMasterId)
        .subscribe(afterUpdateResult => {
          console.log("afterUpdateResult===>", afterUpdateResult);
          if (afterUpdateResult.status == 0) {
            if (this.dtElement.dtInstance != undefined) {
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.destroy();
              });
            }
            $('#userTeamMasterDialog').modal('toggle');
            this.getDefaultUserSelectionList();
            this.close();
          } else {
            $('#userTeamMasterDialog').modal('toggle');
            this.close();
          }
        })

    } else {
      this.userteammasterService.addUserTeamMaster(finalUserTeamMasterData)
        .subscribe(afterSaveResult => {
          console.log("afterSaveResult===>", afterSaveResult);
          if (afterSaveResult.status == 0) {
            if (this.dtElement.dtInstance != undefined) {
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.destroy();
              });
            }
            $('#userTeamMasterDialog').modal('toggle');
            this.close();
            this.getDefaultUserSelectionList();

          } else {
            $('#userTeamMasterDialog').modal('toggle');
            this.close();
          }
        })
    }
  }

  close() {
    this.userTeamMasterForm.controls['username'].setValue('');
    this.userTeamMasterForm.controls['colleague'].setValue('');
    this.userTeamMasterForm.controls['escalation1'].setValue('');
    this.userTeamMasterForm.controls['escalation2'].setValue('');

    $('.selectpickerForColleague option').prop("selected", false);
    $('.selectpickerForColleague').selectpicker('destroy');
    $('.selectpickerForColleague').selectpicker();

    $('.selectpickerForEscalation1 option').prop("selected", false);
    $('.selectpickerForEscalation1').selectpicker('destroy');
    $('.selectpickerForEscalation1').selectpicker();

    $('.selectpickerForEscalation2 option').prop("selected", false);
    $('.selectpickerForEscalation2').selectpicker('destroy');
    $('.selectpickerForEscalation2').selectpicker();
    this.removeAllDisables("ALL")
  }

  resetField(userType) {
    console.log("userType==>", userType);
    if (userType == 'colleague') {
      this.removeAllDisables(userType)
      this.userTeamMasterForm.controls['colleague'].setValue('');
      $('.selectpickerForColleague option').prop("selected", false);
      $('.selectpickerForColleague').selectpicker('destroy');
      $('.selectpickerForColleague').selectpicker();
    }
    else if (userType == 'escalation1') {
      this.removeAllDisables(userType)
      this.userTeamMasterForm.controls['escalation1'].setValue('');
      $('.selectpickerForEscalation1 option').prop("selected", false);
      $('.selectpickerForEscalation1').selectpicker('destroy');
      $('.selectpickerForEscalation1').selectpicker();
    }
    else if (userType == 'escalation2') {
      this.removeAllDisables(userType)
      this.userTeamMasterForm.controls['escalation2'].setValue('');
      $('.selectpickerForEscalation2 option').prop("selected", false);
      $('.selectpickerForEscalation2').selectpicker('destroy');
      $('.selectpickerForEscalation2').selectpicker();
    }
    
  }

  onChange(eve, userType, eventName) {
    if (eventName === "selected") {
      let colleague = this.userTeamMasterForm.controls['colleague'].value
      let escalation1 = this.userTeamMasterForm.controls['escalation1'].value
      let escalation2 = this.userTeamMasterForm.controls['escalation2'].value
      let selectedUsersList = [...colleague, ...escalation1, ...escalation2]
      this.activatedUserList = this.activatedUserList.map(i => {
        if (selectedUsersList.includes(i.value)) {
          return {
            ...i,
            disabled: true
          }
        }
        return i
      })
    } else {
      this.activatedUserList = this.activatedUserList.map(i => {
        if(i.value === eve.value){
          return {
            ...i,
            disabled: false
          }
        }
        return i
      })
    }
    if (userType == 'Colleague') {
      $('.selectpickerForColleague').selectpicker('destroy');
      $('.selectpickerForColleague').selectpicker('refresh');
    }
    else if (userType == 'Escalation1') {
      $('.selectpickerForEscalation1').selectpicker('destroy');
      $('.selectpickerForEscalation1').selectpicker('refresh');
    }
    else if (userType == 'Escalation2') {
      $('.selectpickerForEscalation2').selectpicker('destroy');
      $('.selectpickerForEscalation2').selectpicker('refresh');
    }
  }

  // onChangedeselected(eve, userType) {
    
  //  if (userType == 'Escalation1') {
  //     $('.selectpickerForEscalation1').selectpicker('destroy');
  //     $('.selectpickerForEscalation1').selectpicker('refresh');
  //   }
  //   this.removeAllDisables()
  
  // }

  getDefaultUserSelectionList() {
    var that = this;
    this.activatedUserList = [];
    this.activatedUserListForEdit = [];
    this.userteammasterService.getUsersFromGovevaForDefaultUserSelection()
      .subscribe(dataList => {
        if (dataList.status == 0) {
          this.dataAvailable = true;
          this.activatedUserList = dataList.result;
          this.activatedUserList = this.activatedUserList.map(ele => {
            return {
              label: ele.FirstName + ' ' + ele.LastName,
              value: ele._id,
              ...ele
            }
          })
          that.userteammasterService.getUserTeamMasterData()
            .subscribe(userMasterData => {
              console.log("that.activatedUserListuserMasterData===>", userMasterData);
              var afterFilterResult = [];
              dataList.result.forEach(ob => {
                var userMergeObj = {}
                userMasterData.userDataList.forEach(ob2 => {
                  if (ob.EmailId === ob2.emailId) {
                    userMergeObj['userTeamMasterId'] = ob2._id;
                    userMergeObj['colleagueUserName'] = ob2.colleague.userName;
                    userMergeObj['colleagueUserId'] = ob2.colleague.userId;
                    userMergeObj['escalation1UserName'] = ob2.escalation1.userName;
                    userMergeObj['escalation1'] = ob2.escalation1;
                    userMergeObj['colleague'] = ob2.colleague;
                    userMergeObj['escalation2'] = ob2.escalation2;
                    userMergeObj['escalation1UserId'] = ob2.escalation1.userId;
                    userMergeObj['escalation2UserName'] = ob2.escalation2.userName;
                    userMergeObj['escalation2UserId'] = ob2.escalation2.userId;
                  }
                })

                if (_.isEmpty(userMergeObj)) {
                  userMergeObj['userTeamMasterId'] = "";
                  userMergeObj['colleagueUserName'] = "";
                  userMergeObj['colleagueUserId'] = "";
                  userMergeObj['escalation1UserName'] = "";
                  userMergeObj['escalation1UserId'] = "";
                  userMergeObj['escalation2UserName'] = "";
                  userMergeObj['escalation2UserId'] = "";
                }
                userMergeObj['userId'] = ob._id;
                userMergeObj['uniqueUserId:'] = ob.UniqueUserId;
                userMergeObj['companyId'] = ob.CompanyId;
                userMergeObj['emailid'] = ob.EmailId;
                userMergeObj['userName'] = ob.FirstName + ' ' + ob.LastName;

                afterFilterResult.push(userMergeObj);
              })

              console.log("that.activatedUserList===>", afterFilterResult);

              this.activatedUserListForEdit = afterFilterResult;
              this.dtTrigger.next();
              // var afterFilterResult = _.differenceWith(dataList.result, userMasterData.userDataList, function (o1, o2) {
              //     return (o1['EmailId'] === o2['emailId'] && o1['CompanyId'] === o2['companyId']);
              // });
            })


          $(function () {
            $('.selectpickerForColleague').selectpicker();
            $('.selectpickerForEscalation1').selectpicker();
            $('.selectpickerForEscalation2').selectpicker();
            $('.selectpickerForColleague').selectpicker('refresh');
            $('.selectpickerForEscalation1').selectpicker('refresh');
            $('.selectpickerForEscalation2').selectpicker('refresh');
          });

        } else {
          this.dataAvailable = false;
          this.dtTrigger.next();
        }
      })
  }

  changeTransactionType(value) {
    var formArray: FormArray = <FormArray>this.taskCronDetailsForm.controls.newField;
    var formGroup: FormGroup = <FormGroup>formArray.controls[0];
    // if(value == 'Weekly')
    // {
    //   formGroup.controls.weeklyDay.setValidators([Validators.required]);
    // formGroup.controls.cronDate.setValidators([]);
    // formGroup.controls.cronDate.setValue('');
    // }
    // else{
    //     formGroup.controls.cronDate.setValidators([Validators.required]);
    //     formGroup.controls.weeklyDay.setValidators([]);
    //     formGroup.controls.weeklyDay.setValue('');
    // }
    //   formGroup.controls.weeklyDay.updateValueAndValidity();
    //   formGroup.controls.cronDate.updateValueAndValidity();


    formGroup.controls.weeklyDay.setValue('');
    formGroup.controls.cronDate.setValue('');
  }

  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  }


  initialiseNewFieldArray(): FormGroup {
    return this.formBuilder.group({
      cronName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ,.'&-]*$")]),
      cronFrequency: new FormControl('', [Validators.required]),
      weeklyDay: new FormControl('', []),
      cronDate: new FormControl('', []),
      noOfDays: new FormControl('', [Validators.required, Validators.pattern("^[0-9 ]+$")]),
      emailTo: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-z]{2,}$")]),
    })
  }


  addNewFieldsModal() {
    this.addholding = true;
    $("#addNewForm").modal('toggle');
    this.addNewFields();
  }

  addNewFields() {

    var formArray: FormArray = <FormArray>this.taskCronDetailsForm.controls.newField;
    var formArraySize = _.size(formArray.controls);

    formArray.push(this.initialiseNewFieldArray());
    var formGroup: FormGroup = <FormGroup>formArray.controls[formArraySize];

    console.log("taskCronDetailsForm", this.taskCronDetailsForm);
    this.newFieldAttribute = { 'newFieldValue': '', 'defaultValue': '' };
    this.newFieldArray.push(this.newFieldAttribute);
  }
  resetFields() {
    var formArray: FormArray = <FormArray>this.taskCronDetailsForm.controls.newField;
    const index = _.size(formArray.controls);
    for (let i = index - 1; i >= 0; i--) {
      this.newFieldArray.splice(i, 1);
      formArray = <FormArray>this.taskCronDetailsForm.controls.newField;
      formArray.removeAt(i)
    }
  }
  removeField(index) {
    var newFieldData = this.taskCronDetailsForm.controls.newField.value;
    this.newFieldArray.splice(index, 1);
    var formArray = <FormArray>this.taskCronDetailsForm.controls.newField;
    formArray.removeAt(index)
  }


  getTaskCronDetails() {
    this.holdingList = [];
    this.CronConfigurationsList = [];
      
    this.taskService.getTaskCronDetails().subscribe(holding1List => {
      this.holdingList.push(holding1List.data);
        for(let i=0; i< holding1List.data.length; i++){
          for(let j=0; j< holding1List.data[i].CronConfigurations.length; j++){
            this.CronConfigurationsList.push(holding1List.data[i].CronConfigurations[j]);
             console.log("this.CronConfigurationsList",this.CronConfigurationsList)
           }
          }
          console.log("this.CronConfigurationsList",this.CronConfigurationsList)
          this.dtTriggerHolding.next();
   })
  }


  saveDetailsOfHolding() {
    this.disabledOnClick = true;

    this.holdersdata = [];
    this.taskCronDetailsForm.controls.newField.value.forEach((item, i) => {
      let updatedObject = {

        cronName: this.taskCronDetailsForm.controls.newField.value[i].cronName,
        cronFrequency: this.taskCronDetailsForm.controls.newField.value[i].cronFrequency,
        weeklyDay: this.taskCronDetailsForm.controls.newField.value[i].weeklyDay,
        cronDate: this.taskCronDetailsForm.controls.newField.value[i].cronDate,
        noOfDays: this.taskCronDetailsForm.controls.newField.value[i].noOfDays,
        emailTo: this.taskCronDetailsForm.controls.newField.value[i].emailTo,

      }
      console.log("updatedObject ", updatedObject);

      this.holdersdata.push(updatedObject);
    });

    var object  = {
      particularId: this.editParticularId,
      data: this.holdersdata
    };


    console.log("newField", this.taskCronDetailsForm.controls.newField);
     this.taskService.saveCronConfigurations(this.holdersdata).subscribe(response => {
       this.disabledOnClick = false;
        if (response.status == 0) {
        this.alert.success(response.message);
        this.getTaskCronDetails();
         $("#detailsOfHoldinglistTable").DataTable().destroy();
       }  else {
            $("#detailsOfHoldinglistTable").DataTable().destroy();
              if(response.err_fields){
                this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
                }else{
                 this.alert.error(response.message);
                }
            $("#addNewForm .close").click()
            }
           $("#addNewForm .close").click()
       this.resetFields();
      })
    }

  updateHoldingDetails() {
    this.disabledOnClick = true;
    this.array = this.taskCronDetailsForm.controls.newField;
    var item = this.array.controls[0];
    var holddata = {
      _id: this.holdingdata._id,
      cronName: item.controls.cronName.value,
      cronFrequency: item.controls.cronFrequency.value,
      weeklyDay: item.controls.weeklyDay.value,
      cronDate: item.controls.cronDate.value,
      noOfDays: item.controls.noOfDays.value,
      emailTo: item.controls.emailTo.value,

    }

    // this.holdersdata.push(updatedObject);
    var object = {
      particularId: this.editParticularId,
      id: this.holdingdata._id,
      data: holddata
    };
    console.log("newField", this.taskCronDetailsForm.controls.newField.value);

   this.taskService.updateCronConfigurations(object).subscribe(response => {
      this.disabledOnClick = false;
        console.log("holdingdata", response);
          if (response.status == 0) {
           this.alert.success(response.message);
           
 this.getTaskCronDetails();
            } 
          else {
          this.alert.error(response.message);
          $("#addNewForm").modal('toggle');
          $("#detailsOfHoldinglistTable").DataTable().destroy();
         }
       this.resetFields();
     })

    this.addholding = true;
    $("#detailsOfHoldinglistTable").DataTable().destroy();
    $("#addNewForm .close").click();

  }
  updateCronConfiguration() {
      this.taskService.updateCronConfigurations(this.holdersdata).subscribe(result => {
        if (result) {
            this.alert.success('Configuration updated successfully')
        } else {
      this.alert.error('Oops something went wrong')
      }
    })
  }
 getTaskCronDetailsById(particularId) {
     this.taskService.getTaskCronDetailsById(particularId).subscribe(result => {
     })

  }


  editholdingdetails(id) {
    this.addholding = false;

    var data = this.CronConfigurationsList.filter(function (item) {
      return item._id == id;
    });
    //console.log("****edit*****", data)
    //console.log("****edit*****", data[0])
    this.holdingdata = data[0];
    //console.log("************editthis.holdingdata",this.holdingdata);
    //console.log("****edit*****", this.holdingdata)
    $("#addNewForm").modal('toggle');


    var formArray: FormArray = <FormArray>this.taskCronDetailsForm.controls.newField;
    var formArraySize = _.size(formArray.controls);

    formArray.push(this.initialiseNewFieldArray());
    var formGroup: FormGroup = <FormGroup>formArray.controls[formArraySize];

    console.log("taskCronDetailsForm", this.taskCronDetailsForm);
    this.newFieldAttribute = { 'newFieldValue': '', 'defaultValue': '' };
    this.newFieldArray.push(this.newFieldAttribute);

    formGroup.controls.cronName.setValue(this.holdingdata.cronName);
    formGroup.controls.cronFrequency.setValue(this.holdingdata.cronFrequency);
    formGroup.controls.weeklyDay.setValue(this.holdingdata.weeklyDay);
    formGroup.controls.cronDate.setValue(this.holdingdata.cronDate);
    formGroup.controls.noOfDays.setValue(this.holdingdata.noOfDays);
    formGroup.controls.emailTo.setValue(this.holdingdata.emailTo);
  
  }

  confirmDelete(_id) {
    this.deleteholdingId = _id;
    $("#deleteConfirm").modal('toggle');
  }

  deleteholdingdetail() {
     var Id = this.editParticularId;
    this.taskService.deleteCronConfigurations(this.deleteholdingId).subscribe(response => {
    if (response.status == 0) {
      this.alert.success(response.message);
       $("#deleteConfirm").modal('toggle');
         $("#detailsOfHoldinglistTable").DataTable().destroy(); 
      } else {
        this.alert.error(response.message);
      }
      this.getTaskCronDetails();
     });
  }

  removeAllDisables(userType){
    if(userType === "colleague"){
      let colleague = this.userTeamMasterForm.controls['colleague'].value
      this.activatedUserList = this.activatedUserList.map(i => {
        if(colleague.includes(i.value)){
          return {
            ...i,
            disabled: false
          }
        }
        return i
      })
    } else if(userType === "escalation1"){
      let escalation1 = this.userTeamMasterForm.controls['escalation1'].value
      this.activatedUserList = this.activatedUserList.map(i => {
        if(escalation1.includes(i.value)){
          return {
            ...i,
            disabled: false
          }
        }
        return i
      })
    } else if(userType === "escalation2") {
      let escalation2 = this.userTeamMasterForm.controls['escalation2'].value
      this.activatedUserList = this.activatedUserList.map(i => {
        if(escalation2.includes(i.value)){
          return {
            ...i,
            disabled: false
          }
        }
        return i
      })
    } else {
      this.activatedUserList = this.activatedUserList.map(i => {
        return {
          ...i,
          disabled: false
        }
      })
    }
  }

  maskEmail(email: string): string {
    if(email){
      const [username, domain] = email.split('@');
      return username && domain ? `${username.slice(0, 3)}******@${domain}` : '';
    }
  }

}
